<template>
  <div class="w-100" >

    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      tooltip="Agregar Valor Recargo"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      @click.native="actionSetShowModalAgregarTarifasRecargos(true)"

    />
    <ui-modal
      ref="modal"
      title="Agregar Recargo"
      transition="scale-up"
      size="large"
      @close="closeModalEvent()"
    >
      <recargos-form 
        :closeModal="cerrarModal"
      />
    </ui-modal>
  </div>
</template>

<script>
// Common
import { mapActions,mapState } from "vuex";

import Button from "../../../../common/Button";
import RecargosForm from "./RecargosForm";

export default {
  
  props:[],

  data() {
    return {

    };
  },
  methods: {

      ...mapActions(["ActionSetZindexTablaModal"]),
      ...mapActions("lineas", ["actionSetShowModalAgregarTarifasRecargos"]),
  
      openModal(ref) {
          this.ActionSetZindexTablaModal(true);
          this.$refs[ref].open();
      },
      closeModal(ref) {
          this.$refs[ref].close();
      },
      cerrarModal(){
        this.closeModal("modal");
        this.actionSetShowModalAgregarTarifasRecargos(false);
        this.ActionSetZindexTablaModal(false); 
      },
      closeModalEvent(){
        this.actionSetShowModalAgregarTarifasRecargos(false);
        this.ActionSetZindexTablaModal(false); 
      }

  },
  computed: {
  ...mapState("lineas", ["showModalAgregarTarifasRecargos"]),
    
  },
  components: {
    Button,
    RecargosForm
  },

  watch: {
      showModalAgregarTarifasRecargos: function (_new) {
          _new && this.openModal("modal");
      },
      
  },
};
</script>

<style>

</style>
